import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Paper, Grid, Box } from '@material-ui/core';
import SearchCaseForm from 'features/Tdsat/components/SearchCaseForm';
import { getCaseStatusReport } from 'features/Tdsat/API/TdsatApi';
import { benchMap } from '../CaseListing/SearchByDateForm';
import { useSnackbar } from 'contexts/SnackbarContext';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  section: {
    marginBottom: theme.spacing(3),
  },
  table: {
    minWidth: '100%',
    border: '1px solid #e0e0e0',
  },
  header: {
    marginBottom: theme.spacing(2),
  },
  titleHeading: {
    color: '#000',
    
  },
  sectionHeading: {
    textAlign: 'center',
    color: 'black',
  },
  paper: {
    padding: `3rem 6rem`,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    marginBottom: theme.spacing(4),
    borderRadius: '0.625rem',
  },
  button: {
    padding: '0.7rem 2rem',
    borderRadius: '0.75rem',
    fontSize: '1.25rem',
    margin: '2rem',
  },
  cell: {
    border: "1px solid #ccc",
    padding: theme.spacing(0.5),
    display: "flex",
    alignItems: "center",
  },
  tableHeader: {
    border: "1px solid #ccc",
    padding: theme.spacing(0.5),
    backgroundColor: "#f5f5f5",
  },
  sectionHeading: {
    fontWeight: "bold",
  },
}));

const CaseStatus = () => {
  const classes = useStyles();
  const { showSnackbar } = useSnackbar();
  const [searchResponse, setSearchResponse] = useState(null);
  const [searchFormData, setSearchFormData] = useState({
    selectType: 'caseNumber',
    case_number: '',
    case_type: '',
    diary_number: '',
    year: '',
  });

  const handleInputChangeSearch = (e) => {
    const { name, value } = e.target;
    setSearchFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSearch = async (searchParams) => {
      try {
        setSearchResponse(null);
        const case_number = searchParams?.case_number;
        const case_year = searchParams.year;
        const case_type = searchParams.case_type;
        const diary_number = searchParams?.diary_number;
        const response = await getCaseStatusReport({case_number, case_type, case_year, diary_number});
        setSearchResponse(response?.data);
      } catch (error) {
        console.error("Error searching case:", error);
        if(error?.response?.status === 400){
          showSnackbar(error?.response?.data?.error, 'error');
        }
      }
    };

  return (
    <Box>
      <Box style={{display:'flex', gap:'1rem', justifyContent:'space-between'}}>
        <Typography style={{fontSize:'1.5rem', width:'100%'}}>
          Case Status
        </Typography>
      </Box>
      <Box style={{height:'1.5rem'}}/>
      <SearchCaseForm
        handleInputChange={handleInputChangeSearch}
        classes={classes}
        handleSearch={handleSearch}
        formData={searchFormData}
      />
      {searchResponse && (
        <>
          <Paper className={classes.root}>
            <Box className={classes.section}>
              <Grid container spacing={0}>
                {/* CASE STATUS */}
                <Grid item xs={12} className={classes.tableHeader}>
                  <Typography className={classes.sectionHeading} >
                    CASE STATUS
                  </Typography>
                </Grid>

                <Grid item xs={4} className={classes.cell}>
                  <Typography>Diary No./Year</Typography>
                </Grid>
                <Grid item xs={8} className={classes.cell}>
                  <Typography>{searchResponse.case_status.dairy_no_with_year}</Typography>
                </Grid>

                <Grid item xs={4} className={classes.cell}>
                  <Typography>Case Type/Case No./Year</Typography>
                </Grid>
                <Grid item xs={8} className={classes.cell}>
                  <Typography>{searchResponse.case_status.case_type_case_no_year}</Typography>
                </Grid>

                <Grid item xs={4} className={classes.cell}>
                  <Typography>Date of Filing</Typography>
                </Grid>
                <Grid item xs={8} className={classes.cell}>
                  <Typography>
                    {new Date(searchResponse.case_status.date_filing).toLocaleDateString()}
                  </Typography>
                </Grid>

                <Grid item xs={4} className={classes.cell}>
                  <Typography>Case Status</Typography>
                </Grid>
                <Grid item xs={8} className={classes.cell}>
                  <Typography>{searchResponse.case_status.case_status}</Typography>
                </Grid>

                {/* CASE CURRENT PURPOSE */}
                <Grid item xs={12} className={classes.tableHeader}>
                  <Typography className={classes.sectionHeading} >
                    CASE CURRENT PURPOSE
                  </Typography>
                </Grid>
                <Grid item xs={4} className={classes.cell}>
                  <Typography>Bench</Typography>
                </Grid>
                <Grid item xs={8} className={classes.cell}>
                  <Typography>{benchMap[searchResponse?.case_current_purpose?.bench]}</Typography>
                </Grid>

                <Grid item xs={4} className={classes.cell}>
                  <Typography>Court</Typography>
                </Grid>
                <Grid item xs={8} className={classes.cell}>
                  <Typography>{searchResponse?.case_current_purpose?.court}</Typography>
                </Grid>

                <Grid item xs={4} className={classes.cell}>
                  <Typography>Next Listing Date</Typography>
                </Grid>
                <Grid item xs={8} className={classes.cell}>
                  <Typography>
                    {searchResponse.case_current_purpose.next_listing_date
                      ? new Date(searchResponse.case_current_purpose.next_listing_date).toLocaleDateString()
                      : "N/A"}
                  </Typography>
                </Grid>

                <Grid item xs={4} className={classes.cell}>
                  <Typography>Next Listing Purpose</Typography>
                </Grid>
                <Grid item xs={8} className={classes.cell}>
                  <Typography>{searchResponse?.case_current_purpose?.next_listing_purpose}</Typography>
                </Grid>

                {/* SUBJECT CATEGORY */}
                <Grid item xs={12} className={classes.tableHeader}>
                  <Typography className={classes.sectionHeading} >
                    SUBJECT CATEGORY
                  </Typography>
                </Grid>
                <Grid item xs={4} className={classes.cell}>
                  <Typography>Subj Code</Typography>
                </Grid>
                <Grid item xs={8} className={classes.cell}>
                  <Typography>{searchResponse?.subject_category_code}</Typography>
                </Grid>

                <Grid item xs={4} className={classes.cell}>
                  <Typography>Subject</Typography>
                </Grid>
                <Grid item xs={8} className={classes.cell}>
                  <Typography>{searchResponse?.subject_category_name}</Typography>
                </Grid>

                {/* PETITIONER DETAILS */}
                <Grid item xs={12} className={classes.tableHeader}>
                  <Typography className={classes.sectionHeading} >
                    PETITIONER DETAIL
                  </Typography>
                </Grid>
                <Grid item xs={2} className={classes.cell}>
                  <Typography>Type</Typography>
                </Grid>
                <Grid item xs={2} className={classes.cell}>
                  <Typography>Full Name</Typography>
                </Grid>
                <Grid item xs={4} className={classes.cell}>
                  <Typography>Address</Typography>
                </Grid>
                <Grid item xs={2} className={classes.cell}>
                  <Typography>Phone</Typography>
                </Grid>
                <Grid item xs={2} className={classes.cell}>
                  <Typography>Email</Typography>
                </Grid>

                {searchResponse?.claimant_details?.map((c, i) => (
                  <React.Fragment key={i}>
                    <Grid item xs={2} className={classes.cell}>
                      <Typography>{c?.type}</Typography>
                    </Grid>
                    <Grid item xs={2} className={classes.cell}>
                      <Typography>{c?.full_name}</Typography>
                    </Grid>
                    <Grid item xs={4} className={classes.cell}>
                      <Typography>{c?.correspondence_address}</Typography>
                    </Grid>
                    <Grid item xs={2} className={classes.cell}>
                      <Typography>{c?.phone_number}</Typography>
                    </Grid>
                    <Grid item xs={2} className={classes.cell}>
                      <Typography>{c?.email}</Typography>
                    </Grid>
                  </React.Fragment>
                ))}

                {/* RESPONDENT DETAILS */}
                <Grid item xs={12} className={classes.tableHeader}>
                  <Typography className={classes.sectionHeading} >
                    RESPONDENTS DETAIL
                  </Typography>
                </Grid>
                <Grid item xs={2} className={classes.cell}>
                  <Typography>Type</Typography>
                </Grid>
                <Grid item xs={2} className={classes.cell}>
                  <Typography>Full Name</Typography>
                </Grid>
                <Grid item xs={4} className={classes.cell}>
                  <Typography>Address</Typography>
                </Grid>
                <Grid item xs={2} className={classes.cell}>
                  <Typography>Phone</Typography>
                </Grid>
                <Grid item xs={2} className={classes.cell}>
                  <Typography>Email</Typography>
                </Grid>

                {searchResponse?.respondent_details?.map((r, i) => (
                  <React.Fragment key={i}>
                    <Grid item xs={2} className={classes.cell}>
                      <Typography>{r?.type}</Typography>
                    </Grid>
                    <Grid item xs={2} className={classes.cell}>
                      <Typography>{r?.full_name}</Typography>
                    </Grid>
                    <Grid item xs={4} className={classes.cell}>
                      <Typography>{r?.correspondence_address}</Typography>
                    </Grid>
                    <Grid item xs={2} className={classes.cell}>
                      <Typography>{r?.phone_number}</Typography>
                    </Grid>
                    <Grid item xs={2} className={classes.cell}>
                      <Typography>{r?.email}</Typography>
                    </Grid>
                  </React.Fragment>
                ))}

                {/* CASE PROCEEDING DETAILS */}
                <Grid item xs={12} className={classes.tableHeader}>
                  <Typography className={classes.sectionHeading} >
                    CASE PROCEEDING DETAILS
                  </Typography>
                </Grid>
                <Grid item xs={1} className={classes.cell}>
                  <Typography>Bench No</Typography>
                </Grid>
                <Grid item xs={2} className={classes.cell}>
                  <Typography>Hearing Date</Typography>
                </Grid>
                <Grid item xs={3} className={classes.cell}>
                  <Typography>Purpose</Typography>
                </Grid>
                <Grid item xs={2} className={classes.cell}>
                  <Typography>Status</Typography>
                </Grid>
                <Grid item xs={2} className={classes.cell}>
                  <Typography>Order</Typography>
                </Grid>
                <Grid item xs={2} className={classes.cell}>
                  <Typography>Remark</Typography>
                </Grid>

                {searchResponse?.case_proceeding_details?.map((d, i) => (
                  <React.Fragment key={i}>
                    <Grid item xs={1} className={classes.cell}>
                      <Typography>{d?.bench_no}</Typography>
                    </Grid>
                    <Grid item xs={2} className={classes.cell}>
                      <Typography>{new Date(d?.hearing_date).toLocaleDateString()}</Typography>
                    </Grid>
                    <Grid item xs={3} className={classes.cell}>
                      <Typography>{d?.purpose}</Typography>
                    </Grid>
                    <Grid item xs={2} className={classes.cell}>
                      <Typography>{d?.status}</Typography>
                    </Grid>
                    <Grid item xs={2} className={classes.cell}>
                      <Typography>{d?.order}</Typography>
                    </Grid>
                    <Grid item xs={2} className={classes.cell}>
                      <Typography>{d?.remark}</Typography>
                    </Grid>
                  </React.Fragment>
                ))}

                {/* DOCUMENT DETAILS */}
                {searchResponse?.document_details?.length > 0 && (
                  <>
                    <Grid item xs={12} className={classes.tableHeader}>
                      <Typography className={classes.sectionHeading} >
                        DOCUMENT DETAILS
                      </Typography>
                    </Grid>
                    <Grid item xs={1} className={classes.cell}>
                      <Typography>S.No</Typography>
                    </Grid>
                    <Grid item xs={4} className={classes.cell}>
                      <Typography>Document</Typography>
                    </Grid>
                    <Grid item xs={2} className={classes.cell}>
                      <Typography>Filed By</Typography>
                    </Grid>
                    <Grid item xs={3} className={classes.cell}>
                      <Typography>Name</Typography>
                    </Grid>
                    <Grid item xs={2} className={classes.cell}>
                      <Typography>Date of Filing</Typography>
                    </Grid>

                    {searchResponse?.document_details.map((doc, i) => (
                      <React.Fragment key={i}>
                        <Grid item xs={1} className={classes.cell}>
                          <Typography>{i + 1}</Typography>
                        </Grid>
                        <Grid item xs={4} className={classes.cell}>
                          <Typography>{doc?.document}</Typography>
                        </Grid>
                        <Grid item xs={2} className={classes.cell}>
                          <Typography>{doc?.filed_by}</Typography>
                        </Grid>
                        <Grid item xs={3} className={classes.cell}>
                          <Typography>{doc?.name}</Typography>
                        </Grid>
                        <Grid item xs={2} className={classes.cell}>
                          <Typography>
                            {new Date(doc?.date_of_filing).toLocaleDateString()}
                          </Typography>
                        </Grid>
                      </React.Fragment>
                    ))}
                  </>
                )}
              </Grid>
            </Box>
          </Paper>
        </>
      )}
    </Box>
  );
};

export default CaseStatus;
